/* global OneTrust _satellite */

const RLX_CONSENT_COOKIE = 'rlx-consent';
const RLX_MARKETING_COOKIE = 'rlx-marketing';
const ONETRUST_ANALYTICS_GROUP = 'C0002';
const ONETRUST_MARKETING_GROUP = 'C0004';
const RLX_CORNER_ORIGIN = 'https://cornersv7.rolex.com';
const COOKIE_DAYS = 365;

let rlxConsentWasGranted = false;
let rlxMarketingWasGranted = false;
let rlxConsentListenerRegistered = false;
let rlxCornerConsentSignalled = false;

function rlxConsentCookieExists() {
    return document.cookie.split(';').some((part) => part.trim().indexOf(`${RLX_CONSENT_COOKIE}=`) === 0);
}

function getRlxConsent() {
    const parts = document.cookie.split(';');
    for (const part of parts) {
        const trimmed = part.trim();
        if (trimmed.indexOf(`${RLX_CONSENT_COOKIE}=`) === 0) {
            return trimmed.substring(`${RLX_CONSENT_COOKIE}=`.length);
        }
    }
    return null;
}

function setRlxConsent(value) {
    const expires = new Date();
    expires.setTime(expires.getTime() + (COOKIE_DAYS * 24 * 60 * 60 * 1000));
    let cookie = `${RLX_CONSENT_COOKIE}=${value}; expires=${expires.toUTCString()}; path=/; SameSite=Lax`;
    if (window.location.protocol === 'https:') {
        cookie += '; Secure';
    }
    document.cookie = cookie;
}

function rlxMarketingCookieExists() {
    return document.cookie.split(';').some((part) => part.trim().indexOf(`${RLX_MARKETING_COOKIE}=`) === 0);
}

function getRlxMarketing() {
    const parts = document.cookie.split(';');
    for (const part of parts) {
        const trimmed = part.trim();
        if (trimmed.indexOf(`${RLX_MARKETING_COOKIE}=`) === 0) {
            return trimmed.substring(`${RLX_MARKETING_COOKIE}=`.length);
        }
    }
    return null;
}

function setRlxMarketing(value) {
    const expires = new Date();
    expires.setTime(expires.getTime() + (COOKIE_DAYS * 24 * 60 * 60 * 1000));
    let cookie = `${RLX_MARKETING_COOKIE}=${value}; expires=${expires.toUTCString()}; path=/; SameSite=Lax`;
    if (window.location.protocol === 'https:') {
        cookie += '; Secure';
    }
    document.cookie = cookie;
}

function getOneTrustActiveGroups() {
    if (typeof window.OptanonActiveGroups === 'string') {
        return window.OptanonActiveGroups;
    }
    if (typeof window.OnetrustActiveGroups === 'string') {
        return window.OnetrustActiveGroups;
    }
    return '';
}

function isOneTrustGroupGrantedFromConsentCookie(groupId) {
    const match = document.cookie.match(/(?:^|;\s*)OptanonConsent=([^;]*)/);
    if (!match) {
        return null;
    }

    let consentValue = match[1];
    try {
        consentValue = decodeURIComponent(consentValue);
    } catch (error) {
        // Use the raw cookie value if decoding fails.
    }

    const groupsMatch = consentValue.match(/groups=([^&]*)/);
    if (!groupsMatch) {
        return null;
    }

    return groupsMatch[1].split(',').some((group) => {
        const [id, value] = group.split(':');
        return id === groupId && value === '1';
    });
}

function isOneTrustGroupGranted(groupId) {
    if (window.OneTrust && typeof OneTrust.IsGroupActive === 'function') {
        return OneTrust.IsGroupActive(groupId) === true;
    }

    const activeGroups = getOneTrustActiveGroups();
    if (activeGroups.indexOf(`,${groupId},`) !== -1) {
        return true;
    }

    const fromConsentCookie = isOneTrustGroupGrantedFromConsentCookie(groupId);
    if (fromConsentCookie !== null) {
        return fromConsentCookie;
    }

    return false;
}

function isOneTrustAnalyticsGranted() {
    return isOneTrustGroupGranted(ONETRUST_ANALYTICS_GROUP);
}

function isOneTrustMarketingGranted() {
    return isOneTrustGroupGranted(ONETRUST_MARKETING_GROUP);
}

function isRolexPage() {
    return document.body && document.body.classList.contains('is-rolex');
}

function syncRlxSatelliteVars(analyticsGranted, marketingGranted) {
    if (typeof window._satellite !== 'object') {
        return;
    }

    window._satellite.setVar('Analyticsconsent', analyticsGranted ? 'true' : 'false');
    window._satellite.setVar('Marketingconsent', marketingGranted ? 'true' : 'false');
}

function getRlxCornerFrame() {
    const frameById = document.getElementById('rlx-corner');
    if (frameById && frameById.contentWindow) {
        return frameById;
    }

    const mount = document.getElementById('rlxCorner');
    if (mount) {
        const iframe = mount.querySelector('iframe');
        if (iframe && iframe.contentWindow) {
            return iframe;
        }
    }

    return null;
}

function notifyRlxCornerConsent(analyticsGranted, marketingGranted) {
    const rlxCornerFrame = getRlxCornerFrame();
    if (!rlxCornerFrame) {
        return;
    }

    if (analyticsGranted) {
        rlxCornerFrame.contentWindow.postMessage('consentTrue', RLX_CORNER_ORIGIN);
    } else {
        rlxCornerFrame.contentWindow.postMessage('consentFalse', RLX_CORNER_ORIGIN);
    }

    if (marketingGranted) {
        rlxCornerFrame.contentWindow.postMessage('marketingTrue', RLX_CORNER_ORIGIN);
    } else {
        rlxCornerFrame.contentWindow.postMessage('marketingFalse', RLX_CORNER_ORIGIN);
    }

    if ((analyticsGranted || marketingGranted) && !rlxCornerConsentSignalled) {
        rlxCornerFrame.contentWindow.postMessage('consentValidation', RLX_CORNER_ORIGIN);
        rlxCornerConsentSignalled = true;
    }
}

function syncRlxConsent() {
    const granted = isOneTrustAnalyticsGranted();
    setRlxConsent(granted ? 'true' : 'false');
    syncRlxSatelliteVars(granted, getRlxMarketing() === 'true');

    if (typeof window._satellite === 'object' && granted && !rlxConsentWasGranted) {
        window._satellite.track('PageView');
    }

    rlxConsentWasGranted = granted;
}

function syncRlxMarketing() {
    const granted = isOneTrustMarketingGranted();
    setRlxMarketing(granted ? 'true' : 'false');
    syncRlxSatelliteVars(getRlxConsent() === 'true', granted);
    rlxMarketingWasGranted = granted;
}

function syncRlxCookies() {
    const analyticsGranted = isOneTrustAnalyticsGranted();
    const marketingGranted = isOneTrustMarketingGranted();

    setRlxConsent(analyticsGranted ? 'true' : 'false');
    setRlxMarketing(marketingGranted ? 'true' : 'false');
    syncRlxSatelliteVars(analyticsGranted, marketingGranted);
    notifyRlxCornerConsent(analyticsGranted, marketingGranted);

    if (typeof window._satellite === 'object' && analyticsGranted && !rlxConsentWasGranted) {
        window._satellite.track('PageView');
    }

    rlxConsentWasGranted = analyticsGranted;
    rlxMarketingWasGranted = marketingGranted;
}

function grantAllRlxCookies() {
    setRlxConsent('true');
    setRlxMarketing('true');
    syncRlxSatelliteVars(true, true);
    notifyRlxCornerConsent(true, true);

    if (typeof window._satellite === 'object' && !rlxConsentWasGranted) {
        window._satellite.track('PageView');
    }

    rlxConsentWasGranted = true;
    rlxMarketingWasGranted = true;
}

function whenSatelliteReady(callback) {
    if (typeof window._satellite === 'object') {
        callback();
        return;
    }

    let attempts = 0;
    const interval = window.setInterval(function () {
        attempts += 1;
        if (typeof window._satellite === 'object') {
            window.clearInterval(interval);
            callback();
        } else if (attempts >= 100) {
            window.clearInterval(interval);
        }
    }, 100);
}

function initRlxSatelliteSync() {
    if (!isRolexPage()) {
        return;
    }

    whenSatelliteReady(syncRlxCookies);
}

function registerOneTrustListeners() {
    if (rlxConsentListenerRegistered) {
        return;
    }

    if (window.OneTrust && typeof OneTrust.OnConsentChanged === 'function') {
        OneTrust.OnConsentChanged(function () {
            rlxCornerConsentSignalled = false;
            syncRlxCookies();
        });
    }

    window.addEventListener('OneTrustGroupsUpdated', function () {
        rlxCornerConsentSignalled = false;
        syncRlxCookies();
    });

    rlxConsentListenerRegistered = true;
}

function optanonWrapper() {
    syncRlxCookies();
    registerOneTrustListeners();
}

if (!rlxConsentCookieExists()) {
    setRlxConsent('false');
}

if (!rlxMarketingCookieExists()) {
    setRlxMarketing('false');
}

rlxConsentWasGranted = getRlxConsent() === 'true';
rlxMarketingWasGranted = getRlxMarketing() === 'true';

if (document.body) {
    initRlxSatelliteSync();
} else {
    document.addEventListener('DOMContentLoaded', initRlxSatelliteSync);
}

window.syncRlxConsent = syncRlxConsent;
window.syncRlxMarketing = syncRlxMarketing;
window.syncRlxCookies = syncRlxCookies;
window.grantAllRlxCookies = grantAllRlxCookies;
window.OptanonWrapper = optanonWrapper;
